var app = angular.module('app');
app.controller('appCtrl', ["$scope", "$firebaseAuth", "$firebaseArray", function ($scope, $firebaseAuth, $firebaseArray) {
    $scope.title = 'Bosses';
    $scope.authObj = $firebaseAuth();
    $scope.authObj.$onAuthStateChanged(function (firebaseUser) {
        if (firebaseUser) {
            firebaseUser.getIdTokenResult().then(function(idTokenResult) {
                $scope.$apply(function() {
                    $scope.isAuthenticated = true;
                    $scope.isAdmin = !!idTokenResult.claims.admin;
                });
            });
        } else {
            window.location.href = '/login/login';
        }
    }, function (error) {
        console.error("Authentication state error:", error);
    });

    var ref = firebase.database().ref();
    $scope.remoteItems = $firebaseArray(ref.child("boss"));
    $scope.zones = $firebaseArray(ref.child("zone"));
    $scope.expansions = $firebaseArray(ref.child("expansion"));
    $scope.DB = [];
    $scope.selectedExpansionId = null;

    $scope.selectExpansion = function(id) {
        $scope.selectedExpansionId = id;
    };

    $scope.expansions.$loaded().then(function() {
        for (var i = 0; i < $scope.expansions.length; i++) {
            if ($scope.expansions[i].name === "Echoes of Faydwer") {
                $scope.selectedExpansionId = $scope.expansions[i].$id;
                break;
            }
        }
        if (!$scope.selectedExpansionId && $scope.expansions.length > 0) {
            $scope.selectedExpansionId = $scope.expansions[0].$id;
        }
    });

    $scope.remoteItems.$loaded().then(function () {
        angular.forEach($scope.remoteItems, function (item) {
            var newItem = new Object();
            newItem.$id = item.$id;
            newItem.name = item.name;
            newItem.expansion = item.expansion;
            newItem.zone = item.zone;
            newItem.points = item.points;
            $scope.DB.push(newItem);
        });
    });

    $scope.getExpansionName = function(expansionId) {
        if (!expansionId) return '';
        var record = $scope.expansions.$getRecord(expansionId);
        return record ? record.name : 'Loading...';
    };

    $scope.getZoneName = function(zoneId) {
        if (!zoneId) return '';
        var record = $scope.zones.$getRecord(zoneId);
        return record ? record.name : 'Loading...';
    };

    $scope.add = function () {
        window.location.href = '/boss/add';
    };

    $scope.edit = function (value) {
        window.location.href = '/boss/edit?id=' + value.$id;
    };

    $scope.delete = function (item) {
        if (confirm('Would you like to delete ' + item.name + ' now?')) {
            var record = $scope.remoteItems.$getRecord(item.$id);
            $scope.remoteItems.$remove(record).then(function () {
                var index = $scope.DB.indexOf(item);
                if (index > -1) $scope.DB.splice(index, 1);
            });
        }
    };
}]);